import PaymentMethods from './PaymentMethods';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withProps from 'recompose/withProps';
import lifecycle from 'recompose/lifecycle';
import isEmpty from 'lodash/isEmpty';
import formatPrismicData from '../../hocs/formatPrismicData';
import { withModel } from '../../data-providers/model';
import { getCart, hasCartFailed, isCartPending } from '../../../store/selectors/cart';
import { getPaymentMethods } from '../../../store/thunks/cart';
import { getCookies } from '../../../facades/eagle/helpers/cookies';
import withCountry from '../../hocs/withCountry';

const enhance = compose(
  formatPrismicData,
  withCountry,
  withModel,
  withState('submittingMethod', 'setSubmittingMethod', null),
  connect(
    state => ({
      orderIsPending: isCartPending(state),
      hasOrderFailed: hasCartFailed(state),
      order: getCart(state),
      paymentMethods: getCart(state).paymentMethods || {},
    }),
    dispatch => ({
      getPaymentMethods: (countryModel, errorMessage) =>
        dispatch(getPaymentMethods(getCookies(), countryModel, errorMessage)),
    })
  ),
  withProps(props => {
    let items = props.items;
    if (!isEmpty(props.paymentMethods.items)) {
      items = props.items.filter(item => {
        return props.paymentMethods.items.includes(item.paymentMethodType);
      });
    }
    return { items, settings: props.paymentMethods.settings };
  }),
  lifecycle({
    componentDidMount() {
      const props = this.props;
      props.getPaymentMethods(props.model.countryModel, props.model.prismicGlobalContentModel.error.checkout);
    },
  }),
);

export default enhance(PaymentMethods);



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/index.js